export const REQUEST_POLICIES_FETCH_AD = "REQUEST_POLICIES_FETCH_AD";
export const FETCH_POLICIES_AD_SUCCESS = "FETCH_POLICIES_AD_SUCCESS";
export const FETCH_POLICIES_AD_FAILURE = "FETCH_POLICIES_AD_FAILURE";

export const CLEAR_FETCH_POLICIES_AD_STATES = "CLEAR_FETCH_POLICIES_AD_STATES";
